import { jsx as t } from "react/jsx-runtime";
import "../Button/Button.mjs";
import { IconButton as r } from "../Button/IconButton.mjs";
import "../Button/ButtonGroup.mjs";
import { MagnifyingGlassIcon as a } from "../../icons/componentIcons.mjs";
const c = ({ onClick: o }) => /* @__PURE__ */ t(
  r,
  {
    onClick: o,
    borderLeftRadius: "none",
    "aria-label": "Search",
    className: "search-input-button",
    icon: /* @__PURE__ */ t(a, { variant: "light" })
  }
);
export {
  c as default
};
